import React from 'react';
// components
import ContentHeader from './content-header/content-header';
import ContentTitle from './content-title/content-title';
import ContentText from './content-text/content-text';
import ContentImage from './content-image/content-image';
import ContentItemList from './content-item-list/content-item-list';
import ContentButtons from './content-buttons/content-buttons';
import ContentHtml from './content-html/content-html';
import ContentIconGrid from './content-icon-grid/content-icon-grid';
import ContentBiomarker from './content-biomarker/content-biomarker';
import ContentDnaTraitMarker from './content-dna-trait-marker/content-dna-trait-marker';
import ContentCarousel from './content-carousel';
import ContentSpacer from './content-spacer/content-spacer';

export const renderBlock = (block: any) => {
  switch (block.type) {
    case 'header':
      return <ContentHeader content={block} />;
    case 'title':
      return <ContentTitle content={block} />;
    case 'text':
      return <ContentText content={block} />;
    case 'image':
      return <ContentImage content={block} />;
    case 'itemList':
      return <ContentItemList content={block} />;
    case 'buttons':
      return <ContentButtons content={block} />;
    case 'html':
      return <ContentHtml content={block} />;
    case 'iconGrid':
      return <ContentIconGrid content={block} />;
    case 'biomarkerResults':
      return <ContentBiomarker content={block} />;
    case 'dnaTraitMarker':
      return <ContentDnaTraitMarker content={block} />;
    case 'carousel':
      return <ContentCarousel content={block} />;
    case 'spacer':
      return <ContentSpacer content={block} />;
  }
};
